import React from 'react'
import logo from '../assets/soil-doctor-logo.png'
import { getTranslation } from '../translations'

export default function ReportHeader({ association, language = 'english' }) {
  const t = getTranslation(language)
  
  return (
    <div className="w-full">
      <div className="bg-[#123e28] text-white px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src={logo} alt="Soil Doctor" className="h-10 w-10 rounded-full bg-white object-contain" />
          <span className="text-3xl font-semibold pt-2 pb-2">Soil Doctor</span>
        </div>
        {association && 
        <div className="flex flex-col items-end text-right">
          <span className="italic opacity-90 text-sm">{t.inAssociationWith}</span>
          <span className='text-2xl font-semibold'>{association}</span>
        </div>
        }
      </div>
    </div>
  )
}
